import React, { Fragment } from 'react';
import Slider from 'react-slick';

import { CASE, CONDITIONS, ABOUT, SHARES } from './constants';

import './FooterFreaksStore.scss';

export const FooterFreaksStore = ({ baseImgUrl }) => {
  const caseSetting = {
    infinite: true,
    dots: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    adaptiveHeight: true,
  };

  return (
    <Fragment>
      <section className="footer-freaks-store__case">
        <div className="footer-freaks-store__case__layout">
          <div className="footer-freaks-store__case__header">
            <h2 className="footer-freaks-store__case__title" data-aos="fade-up">
              {CASE.title}
            </h2>
          </div>

          <picture className="footer-freaks-store__case__image" data-aos="fade-up">
            <source media="(min-width: 768px)" srcSet={`${baseImgUrl}/case/main_pc.webp`} />
            <img alt={CASE.alt} loading="lazy" src={`${baseImgUrl}/case/main_sp.webp`} />
          </picture>

          <Slider {...caseSetting} className="footer-freaks-store__case__list">
            {CASE.list.map(({ title, desc }, index) => (
              <li key={`freaks-store__case-${index}`} className="footer-freaks-store__case__item">
                <img
                  alt={CASE.alt}
                  className="footer-freaks-store__case__item-img"
                  src={`${baseImgUrl}/case/preview-${index + 1}.webp`}
                />
                {title && <h3 className="footer-freaks-store__case__item-title">{title}</h3>}
                <p className="footer-freaks-store__case__item-desc">{desc}</p>
              </li>
            ))}
          </Slider>
        </div>

        <div className="base-freaks-store-2025__container">
          <div className="footer-freaks-store__case__buttons">
            <a
              disabled
              className="base-freaks-store-2025__btn"
              href="/sg/en/eyeglasses/brands/freaks-store.html"
            >
              See All Products
            </a>
            <a className="base-freaks-store-2025__btn" href="/stores/sg">
              Find the nearest OWNDAYS store
            </a>
          </div>
        </div>
      </section>

      <section className="footer-freaks-store__conditions">
        <div className="base-freaks-store-2025__container">
          <ul className="footer-freaks-store__conditions__list">
            {CONDITIONS.map(text => (
              <li key={text}>{text}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="footer-freaks-store__about-2025">
        <div className="base-freaks-store-2025__container">
          <h2 className="footer-freaks-store__about-2025__title">
            <img alt="FREAK'S STORE" loading="lazy" src={`${baseImgUrl}/logo/freaks-store.svg`} />
          </h2>

          <p className="footer-freaks-store__about-2025__desc">{ABOUT.desc}</p>

          <a
            className="footer-freaks-store__about-2025__link"
            href={ABOUT.link.url}
            rel="noopener noreferrer"
            target="_blank"
          >
            {ABOUT.link.title}
          </a>
        </div>
      </section>

      <section className="footer-freaks-store__share-2025">
        <div className="footer-freaks-store__share-2025__layout">
          <h2 className="footer-freaks-store__share-2025__title">SHARE</h2>

          <ul className="footer-freaks-store__share-2025__list">
            {SHARES.map(({ link, className }, index) => (
              <li key={index}>
                <a href={link} rel="noopener noreferrer" target="_blank">
                  <i aria-hidden="true" className={`fab ${className}`}></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </Fragment>
  );
};
